import React from 'react'
import { func, string } from 'prop-types'

import { dashboardThumbType } from 'models/propTypes'
import Icon from 'components/uiElements/Icon'

require('./Thumbnail.scss')

const Thumbnail = ({ item, defaultName, onClick, cta, onDelete, ...props }) => {
    const date = new Date(item.creationDate)

    return (
        <div className="Thumbnail" {...props}>
            <div className="thumbnailInner" onClick={onClick}>
                <div className="thumb" style={{ backgroundImage: `url('${item.thumbUrl}')` }}>
                    <div className="controls">
                        {onDelete ? (
                            <button
                                onClick={(e) => {
                                    e.stopPropagation()
                                    onDelete()
                                }}
                                className="delete"
                            >
                                <Icon code="trash" svg />
                            </button>
                        ) : null}
                    </div>
                </div>
                <div className="desc">
                    <div className="ctaContainer">
                        <button className="cta" onClick={onClick}>
                            {cta}
                        </button>
                    </div>
                    <div className="name">{item.name || defaultName || <span>&nbsp;</span>}</div>
                    {item.creationDate ? (
                        <div className="date">
                            <Icon code="calendar" svg />
                            {date.toLocaleDateString()}
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    )
}

Thumbnail.defaultProps = {
    onDelete: null,
    defaultName: null,
}

Thumbnail.propTypes = {
    item: dashboardThumbType.isRequired,
    defaultName: string,
    cta: string.isRequired,
    onClick: func.isRequired,
    onDelete: func,
}

export default Thumbnail
